import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `EmpresaCentro/cambiarEstadoCentroSeleccion`, method: 'POST', body: list, token: token})
}
